export default __webpack_public_path__ + "static/media/logo.a3ce7f55.svg";